import React from 'react';
import { Message, Item, Divider } from 'semantic-ui-react';
import { withApollo, compose } from 'react-apollo';
import TransferForm from './TransferForm';
import { UpdateRefundToPax } from '../../../../mutations/UpdateRefundToPax';
import { UpdateRefundFromAirline } from '../../../../mutations/UpdateRefundFromAirline';
import { UpdateRefundFromLawyer } from '../../../../mutations/UpdateRefundFromLawyer';

const REFUND_FROM_AIRLINE_STATES = [
  'b4_amicable_pending_payment_from_airline',
  'b4_amicable_pending_payment_reminder1',
  'b4_amicable_pending_payment_reminder2',
  'b4_amicable_pending_payment_reminder1_sent'
];

const REFUND_FROM_LAWYER_STATES = [
  'c6_litigation_pending_payment',
  'c6_litigation_pending_payment_reminder1',
  'c6_litigation_pending_payment_reminder1_sent',
  'c6_litigation_pending_payment_reminder2',
  'c6_litigation_pending_payment_reminder2_sent'
];

const PAX_REFUND_STATES = ['b5_pax_to_refund', 'c7_pax_to_refund'];

const Compensation = ({
  client,
  id,
  crmState,
  onClaimUpdated,
  refundFromAirlineAmount,
  refundFromAirlineDate,
  refundToPaxAmount,
  refundToPaxDate,
  refundFromLawyerAmountForPax,
  refundFromLawyerLegalFeesAmount
}) => {
  const refundFromAirline = REFUND_FROM_AIRLINE_STATES.includes(crmState);
  const paxRefund = PAX_REFUND_STATES.includes(crmState);
  const refundFromLawyer = REFUND_FROM_LAWYER_STATES.includes(crmState);

  const handleRefundToPaxSubmit = (values, setSubmitting) => {
    client
      .mutate({
        mutation: UpdateRefundToPax,
        variables: {
          input: {
            id,
            refundToPaxAmount: Number(values.amount),
            refundToPaxDate: values.date
          }
        }
      })
      .then(() => {
        setSubmitting(false);
        onClaimUpdated();
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  const handleRefundFromLawyerSubmit = (values, setSubmitting) => {
    const { amount, legalFees, date } = values;
    client
      .mutate({
        mutation: UpdateRefundFromLawyer,
        variables: {
          input: {
            id,
            refundFromLawyerAmountForPax: Number(amount),
            refundFromLawyerLegalFeesAmount: Number(legalFees),
            refundFromLawyerDate: date
          }
        }
      })
      .then(() => {
        setSubmitting(false);
        onClaimUpdated();
      })
      .catch(() => setSubmitting(false));
  }

  const handleRefundFromAirlineSubmit = (values, setSubmitting) => {
    client
      .mutate({
        mutation: UpdateRefundFromAirline,
        variables: {
          input: {
            id,
            refundFromAirlineAmount: Number(values.amount),
            refundFromAirlineDate: values.date
          }
        }
      })
      .then(() => {
        setSubmitting(false);
        onClaimUpdated();
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  return (
    <Item>
      <Item.Content>
        <Item.Header>Compensation</Item.Header>
        <Divider hidden />
        {refundFromAirline && (
          <TransferForm
            label="Transfer from Airline"
            amount={refundFromAirlineAmount}
            date={refundFromAirlineDate}
            onSubmit={handleRefundFromAirlineSubmit.bind(this)}
          />
        )}
        {refundFromLawyer && (
          <TransferForm
            label="Transfer from Lawyer"
            amount={refundFromLawyerAmountForPax}
            amountLabel="Amount for Pax*"
            legalFees={refundFromLawyerLegalFeesAmount}
            legalFeesLabel="Legal fees*"
            date={refundFromAirlineDate}
            onSubmit={handleRefundFromLawyerSubmit.bind(this)}
          />
        )}
        {paxRefund && (
          <TransferForm
            label="Transfer to Pax"
            amount={refundToPaxAmount}
            date={refundToPaxDate}
            onSubmit={handleRefundToPaxSubmit.bind(this)}
          />
        )}
        {!refundFromAirline && (
          <Message size="mini">
            Transfer from airline inputs visible in states:{' '}
            {REFUND_FROM_AIRLINE_STATES.join(',  ')}
          </Message>
        )}
        {!refundFromLawyer && (
          <Message size="mini">
            Transfer from lawyer inputs visible in states:{' '}
            {REFUND_FROM_LAWYER_STATES.join(',  ')}
          </Message>
        )}
        {!paxRefund && (
          <Message size="mini">
            Transfer to Pax inputs visible in states:{' '}
            {PAX_REFUND_STATES.join(',  ')}
          </Message>
        )}
      </Item.Content>
    </Item>
  );
};

export default compose(withApollo)(Compensation);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Compensation/index.js